import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";


import CallMadeOutlinedIcon from '@mui/icons-material/CallMadeOutlined';
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SidepanelLoader from "../../../theme/sidepanel2/SidepanelLoader";
import Subheading from "../../../theme/text/Subheading";
import Text from "../../../theme/text/Text";

//     {
//         "id": 1,
//         "state": "active",
//         "type": "orders_in_backorder",
//         "body": {
//             "message": "10 {orders_in_backorder}"
//         }
//     },
const OrdersInBackorderNotificationsComp = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    // const cleanedMessage = useMemo(() => {
    //     return props.body.message.replace(/{[^}]*}/g, '').trim();
    // }, [props.body.message]); // Depend on props.body.message


    // const cleanedMessage = useMemo(() => {
    //     return JSON.parse(props.body).message.replace(/{[^}]*}/g, '').trim();
    // }, [props.body]); // Depend on props.body.message

    return(
        <Box
            onClick={props.onClick ?? null}
            sx={{
                cursor:"pointer",
                px:1.5,
                display:"flex",
                gap:2,
                width:1,
                py:1.5,
                transition:"200ms",
                borderRadius:4,
                "&:hover" : {
                    background:colors.grey[100],
                    transition:"200ms",
                }
            }}
        >
            <Box
                sx={{
                    height:32,
                    width:32,
                    flexShrink:0,
                    display:'flex',
                    alignItems:"center",
                    justifyContent:'center',
                    background:theme.palette.mode === "dark" ? colors.pink[100] : colors.pink[100],
                    color:theme.palette.mode === "dark" ? colors.pink[400] : colors.pink[400],
                    borderRadius:3,
                }}
            >
                <CallMadeOutlinedIcon fontSize="small"/>
            </Box>
            <Box flex={1}>
                <Box
                    sx={{
                        display:"flex",
                        alignItems:"center",
                        gap:1,
                        mb:0.5,
                    }}
                >
                    <Text bold>{t(props.type)}</Text> 
                </Box>
                <Box>
                    <Text variant={"pink"}>{props.body}</Text>
                    
                </Box>
            </Box>
        </Box>
    )
}
export default OrdersInBackorderNotificationsComp;